import React, { useContext } from 'react';
import styles from './reportSalary.module.scss';

// Atoms
import ReportHeader from '../../atoms/reportHeader';
import FilterBetweenDates from '../../atoms/filterBetweenDates';
import ReportSalaryDetail from '../../atoms/reportSalaryDetail';
import ReturnStart from '../../atoms/returnStart';

const ReportSalary = () => {

	return(
		<div>
			<ReturnStart />
			<ReportHeader />
			<FilterBetweenDates />
			<ReportSalaryDetail />
		</div>
	);

}

export default ReportSalary;